import { UserTutorialCompletionKey } from '../../../types/userTutorialCompletions';
import { SpBr } from '../../../../commonv3/components/atoms/layouts/br';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { V3Routes } from '../../../routes';
import * as React from 'react';
import './userTutorialDetailAction.module.scss';
import { AnchorButton, Button, Heading } from '@sheinc/shelikes-design-system';

type Props = {
  page_key: UserTutorialCompletionKey;
  hasCompleted: boolean;
  createCompletion: () => void;
  loading: boolean;
};

const isSp = GlobalStatesV3.viewport.isSp;

export const UserTutorialDetailAction = ({ page_key, hasCompleted, createCompletion, loading }: Props) => {
  switch (page_key) {
    case UserTutorialCompletionKey.KEY_COMPLETE_TUTORIAL_COURSE:
      return (
        <div styleName="pane-complete">
          <div styleName="complete-text">
            <Heading size={isSp ? 'S' : 'M'}>SHElikesの使い方コースを受講しよう</Heading>
          </div>
          <div styleName="button-wrap">
            <Button
              onClick={() => GlobalStatesV3.routing.push(V3Routes.course(38))}
              isLoading={loading}
              disabled={hasCompleted}
              id="uncompleted-course-button"
              fullWidth={true}
            >
              {hasCompleted ? 'コースを受講済みです' : 'コースを受講する'}
            </Button>
          </div>
        </div>
      );
    case UserTutorialCompletionKey.KEY_JOIN_SLACK:
      return (
        <div styleName="pane-complete">
          <div styleName="complete-text">
            <Heading size={isSp ? 'S' : 'M'}>
              登録ができた方は
              <SpBr />
              完了ボタンを押そう！
            </Heading>
          </div>
          <div styleName="button-wrap">
            <Button
              onClick={createCompletion}
              isLoading={loading}
              disabled={hasCompleted}
              id="complete-button"
              fullWidth={true}
            >
              {hasCompleted ? '完了済みです' : '完了'}
            </Button>
          </div>
        </div>
      );
    case UserTutorialCompletionKey.KEY_START_COURSE:
      return (
        <div styleName="pane-complete">
          <div styleName="complete-text">
            <Heading size={isSp ? 'S' : 'M'}>コースを1つ受講してみよう！</Heading>
          </div>
          <div styleName="button-wrap">
            <Button
              onClick={() => GlobalStatesV3.routing.push(V3Routes.courses())}
              isLoading={loading}
              disabled={hasCompleted}
              id="uncompleted-course-button"
              fullWidth={true}
            >
              {hasCompleted ? '１つ以上のコースを受講済です' : 'コースを受講する'}
            </Button>
            {hasCompleted && (
              <Button
                onClick={() => GlobalStatesV3.routing.push(V3Routes.courses())}
                isLoading={loading}
                variant="secondary"
                id="course-button"
                fullWidth={true}
              >
                コース一覧へ行く
              </Button>
            )}
          </div>
        </div>
      );
    case UserTutorialCompletionKey.KEY_ATTEND_START_DASH:
      return (
        <div styleName="pane-complete">
          <div styleName="complete-text">
            <Heading size={isSp ? 'S' : 'M'}>スタートダッシュ講座に参加しよう！</Heading>
          </div>
          <div styleName="button-wrap">
            <AnchorButton
              href="https://sheinc.notion.site/0e7b17ebce854b45ba11e142da1d7ea6"
              target="_blank"
              disabled={hasCompleted}
              id="uncompleted-course-button"
              fullWidth={true}
            >
              {hasCompleted ? '参加済みです' : '予約ページへ行く'}
            </AnchorButton>
          </div>
        </div>
      );
    case UserTutorialCompletionKey.KEY_ATTEND_WELCOME_WORKSHOP:
      return (
        <div styleName="pane-complete">
          <div styleName="complete-text">
            <Heading size={isSp ? 'S' : 'M'}>Welcomeワークショップに参加しよう！</Heading>
          </div>
          <div styleName="button-wrap">
            <Button
              onClick={() => GlobalStatesV3.routing.push(V3Routes.coachingSessions2())}
              isLoading={loading}
              disabled={hasCompleted}
              id="uncompleted-course-button"
              fullWidth={true}
            >
              {hasCompleted ? '参加済みです' : '予約ページへいく'}
            </Button>
          </div>
        </div>
      );
    default:
      return (
        <div styleName="pane-complete">
          <div styleName="complete-text">
            <Heading size={isSp ? 'S' : 'M'}>取り組めた方は完了ボタンを押そう！</Heading>
          </div>
          <div styleName="button-wrap">
            <Button onClick={() => createCompletion} isLoading={loading} id="complete-button" fullWidth={true}>
              完了
            </Button>
          </div>
        </div>
      );
  }
};
